import {
  Button,
  Box,
  IconError24,
  Text,
  Link,
  type ButtonProps,
  type TextProps,
} from '@stitch-fix/mode-react';
import { useMachine } from '@xstate/react';
import { addAKidMachine } from '../../machines/add-a-kid/add-a-kid';
import styles from './styles.module.scss';

type AddAKidButtonProps = {
  errorTextColor?: TextProps<'p'>['color'];
} & ButtonProps<'button'>;

export const AddAKidButton = ({
  errorTextColor,
  ...rest
}: AddAKidButtonProps) => {
  const [current, send] = useMachine(addAKidMachine);

  const addAKid = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    send('ADD_A_KID_REQUEST');
  };

  return (
    <>
      <Button
        as="button"
        onClick={addAKid}
        disabled={current.matches('loading')}
        {...rest}
      >
        {current.matches('loading') ? 'Signing Up...' : 'Add a Kid'}
      </Button>
      {current.matches('failure') && (
        <Box mt={0.5} className={styles.error}>
          <IconError24 title="Error" color={errorTextColor} />
          <Text as="p" setting="body-small" color={errorTextColor}>
            {current.matches('failure.limitExceeded') ? (
              <>
                Oops, 6 kids per family account is our current limit! Please{' '}
                <Link
                  href="https://support.stitchfix.com/hc/en-us/requests/new"
                  variant="inherit"
                >
                  contact us
                </Link>{' '}
                if you&apos;d like to add another kid.
              </>
            ) : (
              <>
                Oops, that didn&apos;t work!{' '}
                <Link
                  href="https://support.stitchfix.com/hc/en-us/requests/new"
                  variant="inherit"
                >
                  Contact us
                </Link>
                , we&apos;ll get you all set.
              </>
            )}
          </Text>
        </Box>
      )}
    </>
  );
};
